import React from 'react';
import {
  NEIS_UNREGISTERED_TIMETABLE_CLASS,
  resolveWeeklyGuideNeisCellText,
} from '../../utils/weeklyLearningGuideNeisCellStyle';
import type { WeeklyGuideSlotSurface } from '../../utils/weeklyLearningGuideSurface';

export type WeeklyLearningGuideNeisCellContentProps = {
  slotSurface: WeeklyGuideSlotSurface;
  subject: string;
  neisTrackName?: string;
  neisUnregisteredTimetableText?: string;
  neisDedicated?: boolean;
};

const WeeklyLearningGuideNeisCellContent: React.FC<WeeklyLearningGuideNeisCellContentProps> = (cell) => {
  const { text, unregistered, showDedicatedLabel } = resolveWeeklyGuideNeisCellText(cell);
  if (!text) return null;
  if (unregistered) {
    return <span className={NEIS_UNREGISTERED_TIMETABLE_CLASS}>{text}</span>;
  }
  if (showDedicatedLabel) {
    return (
      <span className="cp-weekly-learning-guide-neis-cell-stack">
        <span className="cp-weekly-learning-guide-neis-track-name">{text}</span>
        <span className="cp-weekly-learning-guide-neis-dedicated-label">(전담)</span>
      </span>
    );
  }
  return <span>{text}</span>;
};

export default WeeklyLearningGuideNeisCellContent;
